// extracted by mini-css-extract-plugin
export var backupIcon = "_p6-1";
export var image = "_p6-0";